import React from 'react';
import PropTypes from 'prop-types';
import CancelledTag from '@/pages/_components/CancelledTag';
import CompletedTag from '@/pages/_components/CompletedTag';
import ExpiredTag from '@/pages/_components/ExpiredTag';
import { isExpired } from '@/utils/dateTimeUtils';

export default function StatusTags(props) {
  const { event } = props;

  if (event.data.cancelled) {
    return (
      <div className="flex space-x-4">
        <CancelledTag resource={event}/>
      </div>
    );
  }

  if (event.data.completed) {
    return (
      <div className="flex space-x-4">
        <CompletedTag resource={event}/>
      </div>
    );
  }

  if (isExpired(event.data.endDate)) {
    return (
      <div className="flex space-x-4">
        <ExpiredTag resource={event}/>
      </div>
    );
  }

  return null;
}

StatusTags.propTypes = {
  event: PropTypes.shape({
    data: PropTypes.shape({
      cancelled: PropTypes.bool,
      completed: PropTypes.bool,
      endDate: PropTypes.string
    })
  }).isRequired
};
